import carmenPic from "@/public/images/artists/carmen.png";
import { Artist } from "@/types/types";

export const carmen = {
  id: "203",
  name: "Carmen",
  image: carmenPic,
  description: `Carmen's voice is effortlessly smooth with a warmth that evokes the best of 90s and 00s R&B. It's rich and inviting, creating a laid-back yet emotionally resonant vibe.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcarmen-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Hip Hop", "Jazz", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
